const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const { formatText } = require('core/i18n').i18n;
const { queryChanged } = require('actions/glossary');
require('./GlossaryInput.scss');

/**
 * Enhanced so that it catches any key stroke even if it's not focused.
 **/
class GlossaryInput extends React.Component {
    constructor(props) {
        super(props);
        this.handleKeyDown = this.handleKeyDown.bind(this);
    }

    componentDidMount() {
        document.addEventListener('keydown', this.handleKeyDown, false);
    }

    componentDidUpdate(prevProps) {
        if (this.props.query === '') {
            this.input.value = '';
        }
        if (!prevProps.glossaryIsOpen && this.props.glossaryIsOpen) {
            this.input.focus();
        }
    }

    componentWilUnmount() {
        document.removeEventListener('keydown', this.handleKeyDown, false);
    }

    handleKeyDown() {
        const { isVisible } = this.props;
        if (isVisible && document.activeElement !== this.input) {
          this.input.focus();
        }
    }

    render () {
        const { changeQuery, query } = this.props;
        return (
            <div className="header--searchbox form-group">
                <input
                    className="form-control searchbox--input"
                    type="text"
                    id="searchbox"
                    name="searchbox"
                    placeholder={formatText('glossary-search')}
                    autoComplete="off"
                    onChange={ev => changeQuery(ev.target.value)}
                    defaultValue={query}
                    ref={input => this.input = input}
                />
            </div>
        );
    }
}


GlossaryInput.propTypes = {
    changeQuery: PropTypes.func.isRequired,
    glossaryIsOpen: PropTypes.bool,
    isVisible: PropTypes.bool,
    query: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
    glossaryIsOpen: state.glossary.isOpen,
    query: state.glossary.query,
});

const mapDispatchToProps = dispatch => ({
    changeQuery: query => dispatch(queryChanged({ query })),
});


module.exports = connect(mapStateToProps, mapDispatchToProps)(GlossaryInput);
